import { render, staticRenderFns } from "./VLongPressButton.vue?vue&type=template&id=5d770b37&"
import script from "./VLongPressButton.vue?vue&type=script&lang=ts&"
export * from "./VLongPressButton.vue?vue&type=script&lang=ts&"
import style0 from "./VLongPressButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports